import { combineReducers } from 'redux';

// Reducers
import sesion from '../sesion';
import usuario from '../usuario';
import razonSocial from '../razonSocial';
import flujo from '../flujo';
import storageBrowser from '../StorageBrowser';
import late from '../late';
import news from '../news';

import app from '../aplication';
import workFlow from '../workFlow';
import actions from '../actions';
import globalData from '../globalData';
import client from '../client';
import users from '../users';
import role from '../role';
import trackingCase from '../trackingCase';
import activity from '../activity';
import history from '../history'
import carCase from '../carCase'
import garmentCar from '../garmentCard';
import userDeny from '../userDeny';
import message from '../message';
import documents from '../documents';
import pay from '../pay';
import report from '../report';

const reducers = combineReducers({
  app:app, 
  sesion: sesion,
  usuario:  usuario,
  razonSocial: razonSocial,
  flujoGrupo: flujo,
  storageBrowser: storageBrowser,
  late:late,
  news:news,
  
  workFlow:workFlow,
  actions:actions,
  globalData:globalData,
  client:client,
  users:users,
  role:role,
  trackingCase:trackingCase,
  activity:activity,
  history:history,
  carCase:carCase,
  garmentCar:garmentCar,
  userDeny:userDeny,
  message:message,
  documents:documents,
  pay:pay,
  report:report
});

export default reducers;
